import axios from '@/_services/axios';

export function GetAll() {
  return new Promise((resolve, reject) => {
    axios
      .get('phases/all')
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetPhaseIndependentSubcontractCost(jobId, phaseId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/phases/${phaseId}/independentSubcontractingCost`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function EditPhaseSubcontractPrice(jobId, id, cost) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/phases/${id}`, {
        cost: cost,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetCompositesFromPhase(phaseId, withoutMaterials = false) {
  return new Promise((resolve, reject) => {
    const query = withoutMaterials ? '?withoutMaterials=1' : '';
    axios
      .get(`phases/${phaseId}/compositePrototypes${query}`)
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function GetAllPhases() {
  return new Promise((resolve, reject) => {
    axios
      .get('phases/all')
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}
